module.exports = __webpack_public_path__ + "static/media/501SunsetAveNW_2018-06-06_57.240185ee.jpg";